module.exports = __webpack_public_path__ + "media/images/emblems/Saint-Oyens-coat_of_arms-50c60c0be5c10efc4388e42d11562b74.svg";